import { useLayoutEffect, useState } from "react";

export function useDimensions(ref: React.RefObject<HTMLDivElement | null>): {
  width: number;
  height: number;
} {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useLayoutEffect(() => {
    if (ref.current) {
      setDimensions(() => ({
        width: ref.current!.offsetWidth,
        height: ref.current!.offsetHeight
      }));
    }
  }, [ref]);

  return dimensions;
}
